export function FatalError({ title, detail }: { title: string; detail: string }) {
  return (
    <div style={{ fontFamily: "system-ui, sans-serif", padding: 32, maxWidth: 720 }}>
      <h1 style={{ fontSize: 20, marginBottom: 8 }}>{title}</h1>
      <pre style={{ whiteSpace: "pre-wrap", background: "#f6f6f6", padding: 12, borderRadius: 6 }}>{detail}</pre>
      <p style={{ color: "#555", fontSize: 14 }}>
        This is a configuration failure, not a transient one. AnkhOS deliberately refuses to start
        rather than fall back to a default identity or endpoint.
      </p>
    </div>
  );
}
